import { css } from '@/styled-system/css';

export const filterChipLabelStyles = css.raw({
  color: 'Chip.label.default',
  hyphens: 'auto',
  textStyle: 'body-sm-bold',
});
